export const STARTED_FETCHING_GUIDE_FOR_STANDALONE_PAGE = 'STARTED_FETCHING_GUIDE_FOR_STANDALONE_PAGE'
export const FINISHED_FETCHING_GUIDE_FOR_STANDALONE_PAGE = 'FINISHED_FETCHING_GUIDE_FOR_STANDALONE_PAGE'
export const RESET_SINGLE_PAGE_GUIDE = 'RESET_SINGLE_PAGE_GUIDE'